import { Locale } from 'date-fns';
import { enUS, nb, sv } from 'date-fns/locale';

interface LocaleDetails {
    i18nLocale: Locale;
    languageName: string;
    languageAbbr: string;
    countryCodes: string[];
}

const localesMap: Record<string, LocaleDetails> = {
    en: { i18nLocale: enUS, languageName: 'English', languageAbbr: 'EN', countryCodes: [ 'US', 'GB' ] },
    sv: { i18nLocale: sv, languageName: 'Svenska', languageAbbr: 'SV', countryCodes: [ 'SE' ] },
    no: { i18nLocale: nb, languageName: 'Norsk', languageAbbr: 'NO', countryCodes: [ 'NO' ] },
    nb: { i18nLocale: nb, languageName: 'Norsk', languageAbbr: 'NO', countryCodes: [ 'NO' ] }
};

export default localesMap;
